/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormRow } from '../../../react/form_row.jsx';
import { FormattedPlainText } from '../../../react/formatted_plain_text.jsx';

export var ComplianceForm = (function() {
  ComplianceForm = class ComplianceForm extends React.Component {
    constructor(...args) {
      super(...args);
      this.renderImplicit = this.renderImplicit.bind(this);
      this.renderExplicit = this.renderExplicit.bind(this);
      this.renderInlineTerms = this.renderInlineTerms.bind(this);
this.render = this.render.bind(this);
    }

    static initClass() {
      this.propTypes = {
        // Compliance level
        level: PropTypes.oneOf(["none", "light", "strong", "hardcore"]),
        // Additional compliance text
        text: PropTypes.string,
        // Agreement URL
        termsUrl: PropTypes.string,
        // Platform Name
        platformName: PropTypes.string,
        // Callback for agreement state change
        onAgreementChange: PropTypes.func,
        // Agreement state
        agreementState: PropTypes.bool,
        // Errors
        errors: PropTypes.string
      };
  
      this.defaultProps = {
        agreementState: false,
        errors: null
      };
    }

    // Render the implicit acceptance message
    renderImplicit() {
      return <div className="em-registration-terms">
        <p>By completing this form, I agree that I'd like to receive information from {this.props.platformName} related to events by email, or other forms of communication.</p>

        <p>You may unsubscribe at any time by following the instructions in the communications received. Your information will be handled in accordance with the Privacy Policy.</p>
      </div>;
    }

    // Render the explicit acceptance message, optionally with the text
    renderExplicit() {
      return <React.Fragment>
        <div className="em-registration-terms">
          <p>By checking "I acknowledge" below, I agree that I'd like to receive information from {this.props.platformName} related to events by email, or other forms of communication.</p>

          <p>You may unsubscribe at any time by following the instructions in the communications received. Your information will be handled in accordance with the Privacy Policy.</p>
        </div>
        <div>
          <label htmlFor="terms_agree" className="em-checkbox">
              <input id="terms_agree" type="checkbox" name="terms_agree" onChange={this.props.onAgreementChange} checked={this.props.agreementState} />
              <span>I acknowledge that I have read and agree to the <a href={this.props.termsUrl} target="_blank" className="link" rel="noreferrer">{this.props.platformName} Terms</a>.</span>
          </label>
          {this.props.errors == "required" && (
            <span className="error_marker" role="alert">
              You must agree to the terms
            </span>
          )}
        </div>
      </React.Fragment>;
    }

    // Render the inline terms acceptance message
    renderInlineTerms() {
      return <React.Fragment>
        <div className="em-registration-terms">
          <FormattedPlainText text={this.props.text} />
        </div>
        <div>
          <label htmlFor="terms_agree" className="em-checkbox">
              <input id="terms_agree" type="checkbox" name="terms_agree" onChange={this.props.onAgreementChange} checked={this.props.agreementState} />
              <span>I acknowledge that I have read and agree to the terms above.</span>
          </label>
          {this.props.errors == "required" && (
            <span className="error_marker" role="alert">
              You must agree to the terms
            </span>
          )}
        </div>
      </React.Fragment>;
    }


    render() {
      switch (this.props.level) {
        case 'light':
          return this.renderImplicit();
        case 'strong':
          return this.renderExplicit();
        case 'hardcore':
          return this.renderInlineTerms();
        default:
          return null;
      }
    }
  };
  ComplianceForm.initClass();
  return ComplianceForm;
}());
